"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProductRelatedImageProperty = exports.productRelatedImagePropertyDefinition = void 0;
exports.productRelatedImagePropertyDefinition = {
    view: {
        label: 'Product related image',
        hint: 'ATTENTION: This image is used to strengthen the brand connection to the athlete/artist. It should contain a drink scene or can in hand. Image will be used on Products & Company. Make sure it\'s cleared via your local Brand manager.',
    },
    constraints: [
        {
            name: 'stencils',
            argument: ['image'],
        },
    ],
    type: 'asset',
    multiple: false,
    name: 'product-related-image',
};
const isProductRelatedImageProperty = (prop) => {
    return prop.name === exports.productRelatedImagePropertyDefinition.name;
};
exports.isProductRelatedImageProperty = isProductRelatedImageProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvZHVjdC1yZWxhdGVkLWltYWdlLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvcHJvZHVjdC1yZWxhdGVkLWltYWdlLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEscUNBQXFDLEdBQUc7SUFDbkQsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLHVCQUF1QjtRQUM5QixJQUFJLEVBQUUseU9BQXlPO0tBQ2hQO0lBQ0QsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUUsQ0FBQyxPQUFPLENBQUM7U0FDcEI7S0FDRjtJQUNELElBQUksRUFBRSxPQUFPO0lBQ2IsUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsdUJBQXVCO0NBQ0UsQ0FBQTtBQUkxQixNQUFNLDZCQUE2QixHQUFHLENBQUMsSUFBa0IsRUFBdUMsRUFBRTtJQUN2RyxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssNkNBQXFDLENBQUMsSUFBSSxDQUFBO0FBQ2pFLENBQUMsQ0FBQTtBQUZZLFFBQUEsNkJBQTZCLGlDQUV6QyJ9